export const isMobile = window.screen.width <= 500;

export const returnAge = (fecha) => {
   var hoy = new Date();
   var cumpleanos = new Date(fecha);
   var edad = hoy.getFullYear() - cumpleanos.getFullYear();
   var m = hoy.getMonth() - cumpleanos.getMonth();

   if (m < 0 || (m === 0 && hoy.getDate() < cumpleanos.getDate())) {
      edad--;
   }

   return edad;
};

export function orderDataByTag(data, order) {
   // filteredData orderTag
   function compare(a, b) {
      let itemA = typeof a[order] === "string" ? a[order].toLowerCase() : a[order];
      let itemB = typeof b[order] === "string" ? b[order].toLowerCase() : b[order];
      let comparison = 0;
      if (itemA > itemB) {
         comparison = 1;
      } else if (itemA < itemB) {
         comparison = -1;
      }
      return comparison;
   }

   const toReturn = data.sort(compare);
   return toReturn;
}

export function reverseDate(dateA) {
   return `${dateA.substring(8, 10)}-${dateA.substring(5, 7)}-${dateA.substring(0, 4)}`;
}
